import React, { ReactNode } from 'react';
import { useBooleanFlags } from '@/core/flags/flags.hooks';
import { Recycling } from '@/core/tamagoshi/icons/Recycling';
import { Warranty } from '@/core/tamagoshi/icons/Warranty';
import { Text } from '@/core/tamagoshi/Text/Text';
import { isItalyPlatform, isUkPlatform } from '@/domains/core/settings/utils';
import { CheckCircleOutline } from '@/domains/core/tamagoshi/icons/CheckCircleOutline';
import { concreteGuaranteeUrl } from '@/domains/productDiscovery/ProductPage/common/components/ConcreteGuarantee/ConcreteGuarantee';
import { concreteGuaranteeContent, concreteGuaranteeHeader, concreteGuaranteeLabel, goodToKnowHeader, translateAttributeName } from '@/domains/productDiscovery/ProductPage/common/modules/GoodToKnow/translations';
import { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';
import { trimNumber } from '@/productDiscovery/ProductPage/common/components/Attributes/components/AttributesTable/utils/trimDecimals';
import { Bullet } from '@/productDiscovery/ProductPage/common/modules/GoodToKnow/Bullet';
import { oneForOneRecoveryContentVersionA, oneForOneRecoveryContentVersionB, oneForOneRecoveryContentVersionBFooter, oneForOneRecoveryHeader, oneForOneRecoveryLabel, oneForOneRecoveryLink, oneForOneRecoveryLinkLabel } from '@/productDiscovery/ProductPage/common/modules/GoodToKnow/components/OneForOneRecovery/translations';
import { SustainableBullets } from '@/productDiscovery/ProductPage/common/modules/GoodToKnow/GoodToKnowSustainable.default';
import { pFormat } from '@/productDiscovery/ProductPage/common/modules/GoodToKnow/GoodToKnowUtils';
import styles from './GoodToKnow.module.scss';
export const GoodToKnow = () => {
  const {
    oneForOneRecoveryVersion,
    attributes = []
  } = useDetail();
  const warranty = attributes.find(attribute => attribute.isWarranty === true);
  const displayOneForOne = !!oneForOneRecoveryVersion && !(isUkPlatform() || isItalyPlatform());
  const [displayConcreteGuarantee] = useBooleanFlags(['concreteGuarantee']);
  return <div role="region">
      <Text type="body1" weight="bold">
        {goodToKnowHeader}
      </Text>
      <ul className={styles.list}>
        {displayConcreteGuarantee && <Bullet icon={<CheckCircleOutline />} modalHeader={concreteGuaranteeHeader} modalContent={concreteGuaranteeContent.format({
        strong: chunks => <strong>{chunks}</strong>,
        br: () => <br key="br" />,
        a: (chunks: ReactNode) => <a href={concreteGuaranteeUrl} target="_blank" rel="noreferrer">
                  {chunks}
                </a>
      })}>
            {concreteGuaranteeLabel}
          </Bullet>}

        <SustainableBullets />

        {!!displayOneForOne && <Bullet icon={<Recycling />} modalHeader={oneForOneRecoveryHeader} modalContent={<OneForOneContent version={oneForOneRecoveryVersion} />}>
            {oneForOneRecoveryLabel}
          </Bullet>}

        {warranty && <Bullet icon={<Warranty />}>
            {`${translateAttributeName('warranty')} ${trimNumber(warranty.value)} ${warranty.unit}`}
          </Bullet>}
      </ul>
    </div>;
};
interface OneForOneContentProps {
  version?: '' | 'A' | 'B';
}
const OneForOneContent = ({
  version
}: OneForOneContentProps) => {
  const isVersionB = version === 'B';
  return <>
      <div>
        {isVersionB ? oneForOneRecoveryContentVersionB.format({
        tag: pFormat
      }) : oneForOneRecoveryContentVersionA.format({
        tag: pFormat
      })}
      </div>
      <a href={oneForOneRecoveryLink} className={styles.link}>
        {oneForOneRecoveryLinkLabel}
      </a>
      {isVersionB && <div>{oneForOneRecoveryContentVersionBFooter}</div>}
    </>;
};